import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { NavLink } from "react-router-dom";
import { AppActionCreators, ProjectActionCreators } from "../actions";
import { HighlightProject } from "../components/projects/HighlightedProjects/HighligtedProject";
import {
  AppLayoutElement,
  ElementType,
  InitiativeMode,
  LinkTarget,
} from "../utils/enums";
import ProjectListProbeItem from "./projects/Project/ProjectListProbeItem";

import map from "lodash.map";
import findIndex from "lodash.findindex";
import get from "lodash.get";

class Index extends Component {
  componentDidMount() {
    this.props.getMainPageProjects();
    this.props.getMainPageProbeProjects();
  }
  render() {
    const {
      applicationImages,
      mainPageProbeProjects,
      isAuth,
      voteExecuting,
      loggedOfficeId,
      loggedUserId,
      isOnlyOneOffice,
      updateConsultationForm,
      appModule,
      initiativeMode,
      tiles,
      eformExternalServiceAddress,
      aswAccountId,
      aswMainProfileId,
      loggedUserIsCitizen,
    } = this.props;

    const proposalSuffixData =
      aswAccountId && aswMainProfileId
        ? `/${aswAccountId}/${aswMainProfileId}`
        : "";

    return (
      <div className="gradient gradient--padding-bottom-40 gradient--border-bottom">
        <div className="main-graphic">
          <div className="graphic container">
            <div className="graphic-container">
              {applicationImages && (
                <img
                  className="graphic-container"
                  src={`data:${applicationImages.topImageContentType};base64,${applicationImages.topImage}`}
                  alt="Obrazek na stronie glównej"
                  title="Obrazek na stronie głównej"
                />
              )}
            </div>
          </div>
          <div id="content" className="go-to-modules container">
            {tiles
              .filter((tile) => {
                const showElement =
                  (tile.onlyAfterLogged && isAuth) ||
                  tile.onlyAfterLogged === false;

                const tileAccess =
                  (appModule.consultation &&
                    tile.id === AppLayoutElement.tileConsultation) ||
                  (appModule.budget &&
                    tile.id === AppLayoutElement.tileBudget) ||
                  (appModule.survey &&
                    tile.id === AppLayoutElement.tileSurvey) ||
                  ((appModule.consultation || appModule.budget) &&
                    tile.id === AppLayoutElement.tileInitiative &&
                    initiativeMode !== InitiativeMode.Hidden) ||
                  tile.id > AppLayoutElement.tileInitiative;

                return tileAccess && showElement;
              })
              .map((tile) => {
                if (!Object.values(AppLayoutElement).includes(tile.id)) {
                  return (
                    <div
                      key={`topElement-${tile.id}`}
                      className="go-to-modules__module"
                      tile={tile.description}
                    >
                      <div className="go-to-modules__icon" aria-hidden="true">
                        <i className={tile.awesomeIcon} />
                      </div>
                      <a
                        href={
                          tile.elementType === ElementType.Link
                            ? tile.linkValue
                            : `${eformExternalServiceAddress}/proposal/${tile.eformId}${proposalSuffixData}`
                        }
                        target={
                          tile.linkTarget === LinkTarget.Self
                            ? "_self"
                            : "_blank"
                        }
                        style={{ textDecoration: "none", color: "#fff" }}
                      >
                        {tile.label}
                      </a>
                    </div>
                  );
                }

                return (
                  <NavLink
                    to={
                      tile.elementType === ElementType.Link
                        ? tile.linkValue
                        : `${eformExternalServiceAddress}/proposal/${tile.eformId}${proposalSuffixData}`
                    }
                    key={`topElement-${tile.id}`}
                    className="go-to-modules__module"
                    title={tile.description}
                  >
                    <div className="go-to-modules__icon" aria-hidden="true">
                      <i className={tile.awesomeIcon} />
                    </div>
                    <div className="go-to-modules__text" aria-hidden="true">
                      {tile.label}
                    </div>
                  </NavLink>
                );
              })}
          </div>
          {this.props.mainPageProjects &&
            this.props.mainPageProjects.length > 0 && (
              <div className="cases container container--rwd-1150-margins">
                {this.props.mainPageProjects.map((item, i) => (
                  <HighlightProject isAuth={isAuth} key={i} {...item} />
                ))}
              </div>
            )}
        </div>

        {appModule.probe && (
          <div className="probes container">
            {map(mainPageProbeProjects, (probe, index) => {
              let consultationFormId = get(
                probe,
                "consultationForms[0].id",
                -1
              );
              let isExecuting =
                findIndex(voteExecuting, (id) => id === consultationFormId) !==
                -1;
              return (
                <ProjectListProbeItem
                  key={`star-probe-${index}`}
                  {...probe}
                  isAuth={isAuth}
                  isExecuting={isExecuting}
                  loggedOfficeId={loggedOfficeId}
                  loggedUserId={loggedUserId}
                  loggedUserIsCitizen={loggedUserIsCitizen}
                  isOnlyOneOffice={isOnlyOneOffice}
                  onSaveProjectVote={updateConsultationForm}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    mainPageProjects: state.app.mainPageProjects,
    applicationImages: state.app.applicationImages,
    mainPageProbeProjects: state.app.mainPageProbeProjects,
    isAuth: state.app.isAuth,
    voteExecuting: state.project.voteExecuting,
    aswAccountId: state.app.loggedUser.aswAccountId || null,
    aswMainProfileId: state.app.loggedUser.aswMainProfileId || null,
    loggedOfficeId: state.app.loggedUser.officeId,
    loggedUserId: state.app.loggedUser.userId,
    loggedUserIsCitizen: state.app.loggedUser.isCitizen || false,
    isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
    appModule: state.app.appModule || {
      consultation: false,
      budget: false,
      probe: false,
      survey: false,
    },
    initiativeMode:
      state.app.initiativeConfiguration.mode || InitiativeMode.Hidden,
    tiles: state.app.tiles || [],
    eformExternalServiceAddress: state.app.eformExternalServiceAddress || "",
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    ...bindActionCreators(
      { ...ProjectActionCreators, ...AppActionCreators },
      dispatch
    ),
    ...{ goTo: (url) => dispatch(push(url)) },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
